import { createSelector } from 'reselect';
import { CallbackSaga, createGeneralCall } from '@altermaind/core/requests-status-management';
import { IS_MOCK_ENABLED } from '@/_shared/constants/mock';
import { GenericPost } from '@/_shared/types';
import { getCurrentOrganization } from '@/core/state/selectors';
import { API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_START_PATH_KEY } from '@/swagger/constants/contents-orchestrator-keys';
import { KEY_POST_CONTENT_START, API_POST_CONTENT_START } from '../constants';
import { MOCK_RESPONSE_POST_CONTENT_START } from '../mocks';

type API_POST_CONTENT_START_PROPS = GenericPost<
  typeof API_ORGANIZATIONS_ORGANIZATIONID_CONTENTS_CONTENTID_START_PATH_KEY
>;

export type RequestPostContentStart = API_POST_CONTENT_START_PROPS['request']['path'];

export type ResponsePostContentStart = API_POST_CONTENT_START_PROPS['response']['body'];

export type CallParamsPostContentStart = Omit<RequestPostContentStart, 'organizationId'> & {
  successSaga?: CallbackSaga;
  errorSaga?: CallbackSaga;
};

export type CallResponsePostContentStart = ResponsePostContentStart;

type CallErrorPostContentStart = {
  message: string;
  code: number;
  type: string;
  title: string;
  status: number;
};

type CallSelectorsPostContentStart = {
  data?: CallResponsePostContentStart;
};

export const postContentStartCall = createGeneralCall<
  CallParamsPostContentStart,
  CallResponsePostContentStart,
  CallErrorPostContentStart,
  CallSelectorsPostContentStart
>({
  id: KEY_POST_CONTENT_START,
  url:
    ({ payload }) =>
    state => {
      const org = getCurrentOrganization(state);
      return API_POST_CONTENT_START(org as unknown as string, payload.contentId);
    },
  method: 'post',
  paramsSelector:
    ({ payload }) =>
    () => {
      return payload;
    },
  selectors: {
    data: ({ selectors }) => createSelector(selectors.response, res => res || undefined),
  },
  successMock: IS_MOCK_ENABLED() ? MOCK_RESPONSE_POST_CONTENT_START : undefined,
});
